import messageService from "../../services/message/messageService";
import store from "../rootReducer";
import { SET_UNREAD_COUNT } from "./notificationVariables";

export async function fetchUnreadMessageCount() {
  const response = await messageService.getUnreadCount();

  if (!response.isOk()) return;

  const data = response.data as { count: number };

  store.dispatch({ type: SET_UNREAD_COUNT, unreadCount: data.count });
}
